import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../../openapi';

@Pipe({
  name: 'locationReconstructionOfExitApplicationParcels2SectionTitle',
  standalone: true
})
export class LocationReconstructionOfExitParcels2SectionTitlePipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.applicationSubject === 'Przebudowy zjazdu': {
        return 'Działki do których prowadzi zjazd';
      }
      default: {
        return 'Działki do których będzie prowadził projektowany zjazd';
      }
    }
  }
}
